import React from 'react';
import { Card } from './ui/card';
import { Phone, Mail, MapPin } from 'lucide-react';

export const ContactInfo = ({ t }) => {
  const contactMethods = [
    {
      icon: Phone,
      label: t.language === 'fr' ? 'Téléphone' : 'Phone',
      value: t.contact.info.phone,
      href: `tel:${t.contact.info.phone}`,
      color: 'text-[#D4AF37]'
    },
    {
      icon: Mail,
      label: 'Email',
      value: t.contact.info.email,
      href: `mailto:${t.contact.info.email}`,
      color: 'text-[#D4AF37]'
    },
    {
      icon: MapPin,
      label: t.language === 'fr' ? 'Adresse' : 'Address',
      value: t.contact.info.address,
      href: null,
      color: 'text-[#D4AF37]'
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-2xl font-bold text-[#001f3f] mb-2">
          {t.language === 'fr' 
            ? 'Le Phare Administratif & Gestion' 
            : 'Le Phare Administratif & Gestion'}
        </h3>
        <p className="text-slate-600 leading-relaxed">
          {t.language === 'fr' 
            ? 'Votre partenaire de confiance pour l\'administration et la gestion d\'entreprise.' 
            : 'Your trusted partner for business administration and management.'}
        </p>
      </div>

      {contactMethods.map((method, index) => {
        const Icon = method.icon;
        return (
          <Card 
            key={`contact-method-${method.label}-${index}`}
            className="p-6 border-slate-200 hover:border-[#D4AF37] hover:shadow-lg transition-all duration-300 group"
          >
            <div className="flex items-start gap-4">
              <div className="p-3 rounded-xl bg-gradient-to-br from-[#001f3f] to-[#003366] group-hover:from-[#D4AF37] group-hover:to-[#FFD700] transition-all duration-300">
                <Icon className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-[#001f3f] mb-1">{method.label}</h4>
                {method.href ? (
                  <a 
                    href={method.href}
                    className={`${method.color} hover:underline transition-colors text-sm break-all`}
                  >
                    {method.value}
                  </a>
                ) : (
                  <p className="text-slate-600 text-sm">{method.value}</p>
                )}
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
